import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=7c820f21&"
import script from "./camera.vue?vue&type=script&lang=ts&"
export * from "./camera.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports